import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'ionic-appauth';
import { Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(private auth: AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.auth.initComplete$.pipe(
      filter((complete) => complete),
      switchMap(() => this.auth.isAuthenticated$),
      tap((isAuthenticated) => {
        if (!isAuthenticated) {
          this.auth.signIn();
        }
      })
    );
  }
}
